import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { Helmet } from 'react-helmet-async';

import {
  PageContainer,
  PageHero,
  Section,
  Protected,
} from '../theme/primitives';

const key = 'dqweqwe123y97qhduiasd$@^!*#&bjasdja&^&@!#';

const advisors = [
  { img: '/assets/newhome/images/pic1.jpg', name: 'Prof. P. Srinivasa Rao', title: 'Former Dean & Board of Governors, IIT-Madras' },
  { img: '/assets/newhome/images/pic3.jpg', name: 'Dr. I. S. N. Raju', title: 'Senior Project Manager (CSDGs), Former Chief Engineer (I&CAD Dept., A.P.), Former Chairman IEI-Hyderabad' },
  { img: '/assets/newhome/images/picnew.jpg', name: 'Dr. G. Rameshwar Rao', title: 'Chairman IEI, TSC: Hyderabad & Director: Engineering Staff College of India' },
  { img: '/assets/newhome/images/pic2.jpg', name: 'Er. D. V. Bhavana Rao (Late)', title: 'Former Chief Engineer, Quality Control, Roads & Buildings Dept., A.P.' },
];

export const Ackdg = () => {
  const [metadata, setMetadata] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    Axios.post('/new_apis/getsinglemetadata', { type: 'thanks' }, { headers: { key } }).then((res) => {
      if (res.data.status) setMetadata(res.data.metadata[0]);
      else setMetadata({
        seo_title: 'Acknowledgments | ESAY',
        seo_desc: 'Our thanks to the professionals and institutions who helped build ESAY.',
        seo_keywords: 'esay acknowledgments, construction engineers',
      });
    });
  }, []);

  return (
    <Protected onCopy={(e) => e.preventDefault()}>
      {metadata && (
        <Helmet>
          <title>{metadata.seo_title}</title>
          <meta name="description" content={metadata.seo_desc} />
          <meta name="keywords" content={metadata.seo_keywords} />
        </Helmet>
      )}

      <PageContainer maxWidth="lg">
        <PageHero
          compact
          kicker="Our gratitude"
          title="Acknowledgments"
          subtitle="The professionals, institutions, and advisors whose support and guidance made ESAY possible."
        />

        <Section>
          <article className="
            relative overflow-hidden rounded-2xl
            border border-amber/24 bg-surface-paper
            p-5 sm:p-7
          ">
            <div
              aria-hidden
              className="pointer-events-none absolute -top-20 -left-20 h-56 w-56 rounded-full"
              style={{ background: 'radial-gradient(circle, rgba(251,191,36,0.14), transparent 65%)' }}
            />
            <span aria-hidden className="pointer-events-none absolute inset-x-8 top-0 h-px bg-gradient-to-r from-transparent via-amber/60 to-transparent" />
            <div className="relative space-y-3 text-[14px] leading-[1.75] text-fg-secondary">
              <p>
                We are grateful to many professionals and organizations who advised and assisted us in creating <strong className="font-bold text-amber">ESAY</strong> - our portal for engineering information and contacts for the construction sector.
              </p>
              <p>
                We gratefully acknowledge the Central Government departments - <strong className="font-bold text-amber">Ministry of Urban Development</strong>, <strong className="font-bold text-amber">Ministry of Water Resources</strong>, various state Government agencies and undertakings, the <strong className="font-bold text-amber">Central Public Works Department</strong>, and research institutes such as <strong className="font-bold text-amber">BIS</strong> and <strong className="font-bold text-amber">IRC</strong> - for placing valuable information in the public domain.
              </p>
              <p>
                The content of this portal also reflects the professional experience of the following renowned engineers, who provided the necessary and vital information to launch it.
              </p>
            </div>
          </article>
        </Section>

        <Section kicker="With thanks" title="Our special thanks to">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
            {advisors.map((a) => (
              <article
                key={a.name}
                className="
                  group relative flex flex-col items-center text-center overflow-hidden
                  rounded-2xl border border-border-subtle bg-surface-paper
                  p-5
                  transition-[border-color,transform,box-shadow] duration-200 ease-out-soft
                  hover:border-amber/40 hover:-translate-y-1 hover:shadow-card-hover
                "
              >
                <span aria-hidden className="pointer-events-none absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-amber/40 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

                <div className="relative">
                  <span aria-hidden className="absolute -inset-1.5 rounded-full border border-amber/24 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                  <img
                    src={a.img}
                    alt={a.name}
                    className="
                      relative h-[110px] w-[110px] rounded-full object-cover
                      bg-surface-overlay border-2 border-amber/30
                      transition-[border-color,transform] duration-300 ease-out-soft
                      group-hover:border-amber/60 group-hover:scale-[1.03]
                    "
                  />
                </div>

                <h3 className="mt-3 text-[14px] font-bold tracking-[-0.01em] text-fg-primary transition-colors duration-200 group-hover:text-amber">
                  {a.name}
                </h3>
                <div aria-hidden className="my-2 h-[2px] w-8 rounded-full bg-gradient-to-r from-amber to-amber/0" />
                <p className="text-[12px] leading-[1.6] text-fg-secondary">{a.title}</p>
              </article>
            ))}
          </div>
        </Section>
      </PageContainer>
    </Protected>
  );
};
